<template>
  <div id="review">
    <div v-show="state == 2" class="top-1">
      <div class="content">
        <img src="@/assets/img/details/btg.png" alt="" />
        <div>
          <span class="h"
            >您的<span v-show="type === 2">学者认证</span
            ><span v-show="type === 1">期刊认证</span
            ><span v-show="type === 4">机构认证</span>未通过审核,请<span
              class="again"
              @click="reauthentication"
              >重新认证</span
            >
          </span>
        </div>
        <div v-if="cause !== 'null' && cause !== ''" class="cause">
          原因：{{ cause }}
        </div>
        <div class="change" @click="ChangeTheType">更换认证类型</div>
      </div>
    </div>
    <div v-show="state == 0" class="top-2">
      <div class="content">
        <img src="@/assets/img/details/shz.png" alt="" />
        <div>
          <span class="h"
            >已收到您的<span v-show="type === 1">期刊认证</span
            ><span v-show="type === 2">学者认证</span
            ><span v-show="type === 4">机构认证</span>申请，请等待审核结果</span
          >
        </div>
      </div>
    </div>
    <div v-show="type === 2 || type === 1 || type === 4" class="bottom">
      <div class="h">审核通过后,您将解锁以下权益</div>
      <!-- 学者 -->
      <div v-show="type === 2" class="content">
        <Icon size="18" type="md-radio-button-on" /><span>开通百家号</span>
        <Icon size="18" type="md-radio-button-on" /><span>个人文献库</span>
        <Icon size="18" type="md-radio-button-on" /><span>资讯内容发布</span>
        <Icon size="18" type="md-radio-button-on" /><span
          >百家在线学者空间</span
        >
      </div>
      <!-- 期刊 -->
      <div v-show="type === 1" class="content">
        <Icon size="18" type="md-radio-button-on" /><span>开通百科号</span>
        <Icon size="18" type="md-radio-button-on" /><span>期刊文献库</span>
        <Icon size="18" type="md-radio-button-on" /><span>资讯内容发布</span>
        <Icon size="18" type="md-radio-button-on" /><span>征稿函发布</span>
        <Icon size="18" type="md-radio-button-on" /><span
          >百家在线期刊空间</span
        >
        <Icon size="18" type="md-radio-button-on" /><span>投审稿业务</span>
      </div>
      <!-- 机构 -->
      <div v-show="type === 4" class="content">
        <Icon size="18" type="md-radio-button-on" /><span>开通机构号</span>
        <Icon size="18" type="md-radio-button-on" /><span>机构文献库</span>
        <Icon size="18" type="md-radio-button-on" /><span>资讯内容发布</span>
        <Icon size="18" type="md-radio-button-on" /><span>文摘发布</span>
        <Icon size="18" type="md-radio-button-on" /><span>报告发布</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "review",
  data() {
    return {
      reviewStatus: 0, //0学者 3期刊
      type: null, //认证类型  1期刊 2学者 4机构
      state: null, //审核状态 0审核中 2审核不通过 1审核通过
      periodicalStatus: 0,
      cause: "", //不通过原因
    };
  },
  computed: {
    // isEdited() {
    //   let bol1 = this.reviewStatus === -1 || this.reviewStatus === 3;
    //   let bol2 = this.periodicalStatus === undefined ? true : this.periodicalStatus === 3 ? true : false;
    //   return bol1 && bol2;
    // },
  },
  methods: {
    // 更换认证类型
    ChangeTheType() {
      this.$router.push("/user/authentication");
    },

    //重新认证
    reauthentication() {
      if (this.type == 2) {
        this.$router.push("/user/scholarRz");
      }
      if (this.type == 1) {
        this.$router.push("/user/periodicalRz");
      }
    },
    // 查询当前认证状态
    async authStatus() {
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
        ? JSON.parse(sessionStorage.getItem("userInfo"))
        : { user: { customerType: 1 } };
      
      const { status, type, cause } = await this.$apis.userServe.authStatus();

      if (status == 1) {
        if (
          userInfo.user.customerType === 2 ||
          userInfo.user.customerType === 4 ||
          userInfo.user.customerType === 5
        ) {
          this.$router.push("/user/mytickets")
        }
      }
      this.type = type;
      this.state = status;
      this.cause = cause;
    },
  },
  mounted() {
    this.authStatus(); //查询当前认证状态
  },
  // beforeRouteEnter(to, from, next) {
  //     let userInfo = JSON.parse(sessionStorage.getItem("userInfo")) ? JSON.parse(sessionStorage.getItem("userInfo")) : { user: { customerType: 1 } };

  // },
};
</script>

<style lang="scss" scoped>
#review {
  width: 1200px;
  height: 100%;
  .top-2 {
    width: 100%;
    height: 668px;
    background: #fff;
    text-align: center;
    box-shadow: 0px 0px 5px rgba($color: #161a64, $alpha: 13%);
    & img {
      margin-top: 230px;
    }
    .h {
      display: block;
      color: #666666;
      margin-top: 33px;
    }
  }
  .top-1 {
    width: 100%;
    min-height: 668px;
    padding: 10px;
    background: #fff;
    text-align: center;
    box-shadow: 0px 0px 5px rgba($color: #161a64, $alpha: 13%);
    & img {
      margin-top: 170px;
    }
    .h {
      display: block;
      color: #666666;
      margin-top: 33px;
      .again {
        color: #2432bd;
        cursor: pointer;
      }
    }
    .cause {
      margin-top: 44px;
      padding: 0 40px;
      word-wrap: break-word;
    }
    .change {
      margin-top: 150px;
      color: #2432bd;
      cursor: pointer;
    }
  }
  .bottom {
    width: 100%;
    height: 410px;
    background: #fff;
    margin-top: 20px;
    box-shadow: 0px 0px 5px rgba($color: #161a64, $alpha: 13%);
    padding-top: 137px;
    text-align: center;
    .h {
      color: #666666;
    }
    .content {
      margin-top: 65px;
      color: #3458eb;
      & span {
        margin-right: 40px;
        margin-left: 6px;
        font-size: 18px;
      }
    }
  }
}
</style>